import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { invoiceFilterSchema } from './filter-schema';
import { filterDefaultValues } from './model';

export function useFilterFormDefinition() {
  return useForm({
    resolver: zodResolver(invoiceFilterSchema),
    defaultValues: filterDefaultValues,
  });
}
